import { useTranslation } from "react-i18next";

export const Marquee = () => {
  const { t } = useTranslation();
  const items = t("marquee.items", { returnObjects: true });
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/5 bg-[#0D0F12] py-8" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-16 whitespace-nowrap pr-16">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-16">
            <span className="font-display text-3xl font-light italic text-[#F9F8F6]/80 md:text-4xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#D6705A]" />
          </span>
        ))}
      </div>
    </div>
  );
};
